import * as acc from './actions/creators';
import * as api from './appointment-api';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';

/*
  Synchronous middleware
*/

const processAppointments = (response) => (dispatch, storeState) =>
  dispatch(acc.appointmentsLoaded(response.data, storeState().facility));

export const setSortField = (property, sortDirection) => (dispatch) =>
  dispatch(acc.setSortField(property, sortDirection));

/*
  Asynchronous middleware
*/

export const loadUpcomingAppointments = (patientId) => (dispatch, storeState) =>
  api.getUpcomingAppointments(patientId).then(
    (response) => {
      dispatch(acc.upcomingAppointmentsLoaded(response.data, storeState().facility));
    },
    () => {
      dispatch(acc.upcomingAppointmentsLoadFailed());
    });

export const patientNotifyPreferenceLoadRequired = (patientId) => (dispatch) =>
  api.getPatientApptNotificationSettings(patientId)
    .then(
      (response) => dispatch(acc.patientNotifyPreferenceLoaded(response.data.patientSettings)),
      (err) => Promise.reject(err)
    );

export const userPreferenceLoadRequired = () =>
  (dispatch, getState) =>
    api.getDateFilterPreference(getState().profile.user.userId)
      .then(
        (response) => dispatch(acc.userPreferenceLoaded(response.data)),
        (err) => Promise.reject(err)
      );

export const appointmentLoadRequired = (patientId) =>
  (dispatch) => api.getAppointments(patientId)
    .then(
      (response) => dispatch(processAppointments(response)),
      () => dispatch(MsgBarActions.showErrorMessage())
    );

export const loadAppointments = (patientId) => (dispatch) => {
  dispatch(patientNotifyPreferenceLoadRequired(patientId));
  return dispatch(userPreferenceLoadRequired())
    .then(
      () => dispatch(appointmentLoadRequired(patientId))
    );
};
